export default function(id: string, category: string, title: string) {
    window.disqus_config = function() {
        const page = (this as any).page;
        page.url = 'https://www.regit.cars' + window.location.pathname;
        page.identifier = 'n' + id;
        page.title = title.replace('/\£/', '\&pound\;');
        page.category_id = '3619321';
    };

    // Prepare the trigger and target
    const isDisqusEmpty = document.getElementById('disqus_empty');
    const disqusTarget = document.getElementById('disqus_thread');
    const disqusEmbed = document.createElement('script');
    const disqusHook = (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]);
    const disqusShortname = 'motoringm';

    // Load script asynchronously only when the trigger and target exist
    if (disqusTarget && isDisqusEmpty) {
        disqusEmbed.type = 'text/javascript';
        disqusEmbed.async = true;
        disqusEmbed.src = '//' + disqusShortname + '.disqus.com/embed.js';
        disqusHook.appendChild(disqusEmbed);
        isDisqusEmpty.remove();
    }
};
